import React from 'react'
import { Link } from 'react-router-dom'
import SEO from '../components/SEO'
import './AboutScreen.css'

// The author's own words. Preserved verbatim — only straight apostrophes were
// curled. If this copy is edited, edit it as writing, not as UI strings.
const CAPABILITIES = [
  'Automatic report generation in SOAP / CHART / DCHART formats',
  'Protocol Q&A to quickly find applicable guidance',
  'Template and document management for your agency',
  'Review and feedback tooling to continuously improve reports',
]

function AboutScreen() {
  return (
    <>
      <SEO
        title="About - PCRAssist"
        description="Learn about PCRAssist: our mission, technology, and how we help clinicians create high‑quality PCRs faster."
        canonicalUrl="/about"
      />

      <div className="ab">
        <article className="ab__wrap">
          <h1 className="ab__title">About PCRAssist</h1>

          <div className="ab__prose">
            <p className="ab__lede">
              Hi, my name is Jos Dijkstra, and I spent several years responding to calls at a
              high-volume EMS station, I&rsquo;ve written countless Patient Care Reports (PCRs) and
              like most EMS personnel, I developed a system using templates for different call
              types: refusal forms, trauma assessments with pertinent negatives, medical calls, and
              standard transport documentation. These templates served as reliable starting points
              that I could quickly modify, expand, or streamline based on each unique patient
              encounter.
            </p>

            <p>
              But no matter how many reports you&rsquo;ve written, you&rsquo;re always wondering, is
              my report complete? Is it accurate? Is it compliant? Is it consistent? This takes away
              valuable time from eating, sleeping, and getting ready for the next call.
            </p>

            <p>
              My background as an engineer gave me a different lens through which to view this
              essential but time-consuming process. When AI technology began advancing rapidly, I
              immediately recognized its potential to revolutionize EMS documentation&mdash;not by
              replacing the medic&rsquo;s clinical judgment or taking control of the narrative, but
              by making the documentation process more efficient and allowing us to focus more on
              patient care.
            </p>

            <p>
              The challenge, of course, is that PCRs aren&rsquo;t just administrative
              paperwork&mdash;they&rsquo;re legal documents that must accurately reflect your
              assessment, your decisions, and your care in your own words. No AI should ever
              generate your report for you. What&rsquo;s needed is a tool that enhances your
              existing workflow while keeping you firmly in control of every word. That&rsquo;s
              exactly what I created pcrassist.com &mdash; a solution that respects both the
              clinical expertise of the medic and the legal requirements of accurate documentation.
            </p>

            <hr className="ab__turn" />

            <h2 className="ab__head">What we do</h2>
            <p>
              PCRAssist helps EMS clinicians produce clear, complete patient care reports faster. We
              combine automatic report classification, structured templates, and feedback workflows
              to reduce documentation time while improving report quality and consistency.
            </p>

            <ul className="ab__list">
              {CAPABILITIES.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>

            <h2 className="ab__head">Our mission</h2>
            <p>
              Make high&#8209;quality PCR documentation effortless, so clinicians can spend more
              time on patient care and less time wrestling with paperwork.
            </p>

            <p className="ab__close">
              Have questions or want to get in touch? Visit our{' '}
              <Link className="ab__link" to="/contact">
                Contact
              </Link>{' '}
              page.
            </p>
          </div>
        </article>
      </div>
    </>
  )
}

export default AboutScreen
